export default __webpack_public_path__ + "static/media/chevron-right1.9a2fbdee.svg";